import React, {Component} from 'react';

const contentStyle = {
  margin: 20,
  textAlign: 'left',
  display: 'inline-block',
};

class KeineAnmeldungMoeglichForm extends Component {
  render() {
    return (
      <div>
        <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
        <div className="text" style={contentStyle}>
          Die Online-Anmeldephase f&uuml;r Ratzgiwatz ist vorbei. Wenn Sie ihr Kind zu einer Aktion des Jugendprogramms anmelden wollen schreiben Sie uns bitte per E-Mail unter jugendprogramm@ratzgiwatz.de
        </div>
      </div>
    );
  }
}

export default KeineAnmeldungMoeglichForm



// WEBPACK FOOTER //
// ./src/components/keine-anmeldung-moeglich/KeineAnmeldungMoeglichForm.jsx